<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      v-el-dialog-drag
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :warehouseCode="editFormDialogOptions.code"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || 取消
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || 保存 }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditForm from '../edit-form'

export default {
  components: {
    PageHeader,
    PageMain,
    EditForm
  },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: ''
      }
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masWarehouseListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('form_label_warehouse_edit') || '编辑库房信息',
        add: this.$l('form_label_warehouse_add') || '增加库房信息',
        detail: this.$l('form_label_warehouse_detail') || '库房信息详情'
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail'
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  }
}
</script>
